<template>
    <div>
     
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="120px" v-model="queryParams">
                 <el-form-item label="仓库选择" prop="warehouseId">
                    <el-select size="small" v-model="queryParams.warehouseId" style="width: 240px"  :clearable="true" filterable :remote-method="remoteMethod1" placeholder="支持搜索" :loading="loading1">
                        <el-option v-for="(option, index) in warehouses" :value="option.id" :key="index" :label="option.name">{{option.name}}
                        </el-option>
                    </el-select>
                </el-form-item>

              
                <el-form-item label="时间">
                    <el-date-picker type="daterange" size="small" @change="cbtime" v-model="others.btime" start-placeholder="开始时间"  value-format="yyyy-MM-dd" end-placeholder="截止时间" style="width: 220px"></el-date-picker>
                  
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <Table :loading="loading" :columns="columns" :data="moneyChangeLogs" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
    </div>
</template>
<script>
import Constants from "@/utils/constants"
export default {
    name: 'MoneyChangeLog',
    data() {
        return {
            loading1:false,
            warehouses:[],
            loading: false,
            modalEdit: false,
            changeTypes: {},
            queryParams: {
                changeType: "11",
                btime: "",
                etime: "",

            },
            others: {
                btime: "",
                etime: "",
            },

            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            moneyChangeLogs: [

            ],
            rules: {},
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 150,
                    align: 'center'
                },{
                    title: '变动前',
                    key: 'moneyBefore',
                    width: 150,
                    align: 'center'
                }, {
                    title: '变动金额',
                    key: 'money',
                    width: 150,
                    align: 'center'
                }, {
                    title: '变动后',
                    key: 'moneyAfter',
                    width: 150,
                    align: 'center'
                }, {
                    title: '时间',
                    key: 'createTime',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2datetime(params.row.createTime))
                        ]);
                    }
                }, {
                    title: '备注',
                    key: 'msg',

                    align: 'center'
                }

            ]
        };
    },
    mounted: function() {

        this.changeTypes = Constants.moneyChangeTypes;
        this.getList();

    },
    methods: {
        remoteMethod1: function(query) {
            var me = this;
            if (query !== '') {
                me.loading1 = true;
                me.$http.post("/ware/warehouse/getall.action", { warehouseName: query }).then(response => {
                    var body = response;
                    if (body.status == 0) {

                        me.warehouses = body.obj;

                    }
                    me.loading1 = false;
                }, response => {
                    me.loading1 = false;
                });
            } else {
                me.warehouses = [];
            }
        },
        cbtime: function(value) {
           if(value)
           {
             this.queryParams.btime = value[0];
            this.queryParams.btime = value[1];
           }
           else{
             this.queryParams.btime = "";
            this.queryParams.btime = "";
           }
        },
        
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
            this.others = {
                btime: "",
                etime: ""
            };
            this.getList();
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/moneylog/getlist.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.moneyChangeLogs = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.errorMessage(response);
                me.loading = false;
            });
        }
    }
}
</script>
<style scoped>
</style>